export default "__VITE_ASSET__Dpne1lf1__"